import React, { useState } from 'react'
import toast from 'react-hot-toast';
import LoadableButton from '../../../../../components/buttons/LoadableButton.jsx';
import { GetPaymentGatewayStatusByIdApi } from '../../../../../api/request/wallet/deposit.js';

const ZaroPayQR = ({ depositdata, resetAll }) => {
    const [isLoading, setIsLoading] = useState(false);

    const getPaymentGatewayStatus = async () => {
        setIsLoading(true);
        try {
            const apiParams = { CRM_OrderId: depositdata?.crM_OrderId };
            const { data } = await GetPaymentGatewayStatusByIdApi(new URLSearchParams(apiParams).toString());
            if (data?.success) {
                if (data?.data.order_status === "SUCCESS") {
                    // setIsOpenModal(false);
                    toast.success("Payment has been completed successfully.");
                    resetAll();
                } else if (data?.data.order_status === "FAILED") {
                    toast.error("Payment failed. Please try again or use a different method.");
                    resetAll();
                } else {
                    toast.error("Payment is still pending. Please wait or refresh after a few seconds.");
                }
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="w-fit space-y-5">
            <div>
                <img src={depositdata?.qr_image} alt='QR' width={100} height={100} className="mx-0" />
            </div>

            <div>
                <div className="flex flex-col sm:flex-row mt-4 items-start sm:items-center">
                    <h3 className="font-semibold min-w-[120px]">Address to Pay:</h3>
                    <p className="sm:ml-6 break-words">{depositdata?.address_to_pay || "-"}</p>
                </div>

                <div className="flex flex-col sm:flex-row mt-4 items-start sm:items-center">
                    <h3 className="font-semibold min-w-[120px]">Order Id:</h3>
                    <p className="sm:ml-6 break-words">{depositdata?.order_id}</p>
                </div>

                <div className="flex flex-col sm:flex-row mt-4 items-start sm:items-center">
                    <h3 className="font-semibold min-w-[120px]">Amount:</h3>
                    <p className="sm:ml-6">$ {depositdata?.price_usdt || 0}</p>
                </div>

                <div className="flex flex-col sm:flex-row mt-4 items-start sm:items-center">
                    <h3 className="font-semibold min-w-[120px]">Amount to Pay:</h3>
                    <h3 className="font-semibold sm:ml-6">$ {depositdata?.amount_to_pay || 0}</h3>
                </div>
            </div>

            <LoadableButton
                className="w-fit bg-primary py-2 text-sm text-white font-semibold rounded-lg px-12 uppercase themeHover duration-500"
                type="submit"
                lable='Verify'
                isLoading={isLoading}
                loadingLable='Verifying...'
                onClick={() => getPaymentGatewayStatus()}
            />
        </div>
    )
}

export default ZaroPayQR
